<template>
  <div class="web-message-container">
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #site_name>
        <a-input
          v-decorator="['site_name',{rules: [
            { required: true, message: '请输入标签名称' },
          ],}]"
          placeholder="请输入标签名称"
        />
      </template>
      <template #wxapp_cover>
        <a-upload
          v-decorator="[
            'wxapp_cover',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('wxapp_cover').length === 1 && $refs.basicForm.form.getFieldValue('wxapp_cover')[0].status === 'done'"
            width="150"
            height="200"
            :src="$refs.basicForm.form.getFieldValue('wxapp_cover')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
        <a-button
          type="danger"
          @click="delImg1"
        >
          删除图片
        </a-button>
      </template>
      <template #wxapp_cover_two>
        <a-upload
          v-decorator="[
            'wxapp_cover_two',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('wxapp_cover_two').length === 1 && $refs.basicForm.form.getFieldValue('wxapp_cover_two')[0].status === 'done'"
            width="150"
            height="200"
            :src="$refs.basicForm.form.getFieldValue('wxapp_cover_two')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
        <a-button
          type="danger"
          @click="delImg2"
        >
          删除图片
        </a-button>
      </template>
      <template #wxapp_covers>
        <a-upload
          v-decorator="[
            'wxapp_covers',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('wxapp_covers').length === 1 && $refs.basicForm.form.getFieldValue('wxapp_covers')[0].status === 'done'"
            width="150"
            height="200"
            :src="$refs.basicForm.form.getFieldValue('wxapp_covers')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
        <a-button
          type="danger"
          @click="delImg3"
        >
          删除图片
        </a-button>
      </template>
      <template #site_slide_promoter_user>
        <a-input
          v-decorator="['site_slide_promoter_user',{rules: [
            { required: false, message: '请输入推广员个人中心广告位' },
          ],}]"
          placeholder="请输入推广员个人中心广告位"
        />
      </template>
      <template #site_slide_doctor_index>
        <a-input
          v-decorator="['site_slide_doctor_index',{rules: [
            { required: false, message: '请输入医生首页广告位' },
          ],}]"
          placeholder="请输入医生首页广告位"
        />
      </template>
      <template #site_slide_doctor_user>
        <a-input
          v-decorator="['site_slide_doctor_user',{rules: [
            { required: false, message: '请输入医生个人中心广告位' },
          ],}]"
          placeholder="请输入医生个人中心广告位"
        />
      </template>
      <template #site_video_vframe>
        <a-input
          v-decorator="['site_video_vframe',{rules: [
            { required: false, message: '请输入视频封面设置' },
          ],}]"
          placeholder="请输入视频封面设置"
        />
      </template>
      <template #site_pop_task_receive_notification>
        <a-input
          v-decorator="['site_pop_task_receive_notification',{rules: [
            { required: false, message: '请输入推广端任务接收通知模版' },
          ],}]"
          placeholder="请输入推广端任务接收通知模版"
        />
      </template>
      <template #site_pop_bangding_notification>
        <a-input
          v-decorator="['site_pop_bangding_notification',{rules: [
            { required: false, message: '请输入推广端医生绑定通知模版' },
          ],}]"
          placeholder="请输入推广端医生绑定通知模版"
        />
      </template>
      <template #site_pop_fankui_notification>
        <a-input
          v-decorator="['site_pop_fankui_notification',{rules: [
            { required: false, message: '推广端医生反馈任务通知模版' },
          ],}]"
          placeholder="推广端医生反馈任务通知模版"
        />
      </template>
      <template #site_task_receive_notification>
        <a-input
          v-decorator="['site_task_receive_notification',{rules: [
            { required: false, message: '请输入医生端任务接收通知模版' },
          ],}]"
          placeholder="请输入医生端任务接收通知模版"
        />
      </template>

      <template #site_message_notification>
        <a-input
          v-decorator="['site_message_notification',{rules: [
            { required: false, message: '请输入推广端留言通知' },
          ],}]"
          placeholder="请输入推广端留言通知"
        />
      </template>
      <template #site_doctor_message_notification>
        <a-input
          v-decorator="['site_doctor_message_notification',{rules: [
            { required: false, message: '请输入医生端留言通知' },
          ],}]"
          placeholder="请输入医生端留言通知"
        />
      </template>
      <template #site_seo_title>
        <a-input
          v-decorator="['site_seo_title',{rules: [
            { required: false, message: '请输入SEO标题' },
          ],}]"
          placeholder="请输入SEO标题"
        />
      </template>
      <template #site_seo_keywords>
        <a-input
          v-decorator="['site_seo_keywords',{rules: [
            { required: false, message: '请输入SEO关键字' },
          ],}]"
          placeholder="请输入SEO关键字"
        />
      </template>
      <template #site_seo_description>
        <a-input
          v-decorator="['site_seo_description',{rules: [
            { required: false, message: '请输入SEO描述' },
          ],}]"
          placeholder="请输入SEO描述"
        />
      </template>
      <template #survey_img>
        <a-upload
          v-decorator="[
            'survey_img',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('survey_img').length === 1 && $refs.basicForm.form.getFieldValue('survey_img')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('survey_img')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #task_one_img>
        <a-upload
          v-decorator="[
            'task_one_img',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('task_one_img').length === 1 && $refs.basicForm.form.getFieldValue('task_one_img')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('task_one_img')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #task_two_img>
        <a-upload
          v-decorator="[
            'task_two_img',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('task_two_img').length === 1 && $refs.basicForm.form.getFieldValue('task_two_img')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('task_two_img')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #task_three_img>
        <a-upload
          v-decorator="[
            'task_three_img',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('task_three_img').length === 1 && $refs.basicForm.form.getFieldValue('task_three_img')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('task_three_img')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
      <template #wxapp_api_cover>
        <a-upload
          v-decorator="[
            'wxapp_api_cover',
            {
              rules: [{ required: false, message: '请上传图片' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          accept=".jpg, .png, .jpeg"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :data="{fileType:'img',}"
          :action="`${uploadUrl}fileup/up`"
          :before-upload="beforeUpload"
        >
          <img
            v-if="$refs.basicForm && $refs.basicForm.form.getFieldValue('wxapp_api_cover').length === 1 && $refs.basicForm.form.getFieldValue('wxapp_api_cover')[0].status === 'done'"
            width="100"
            height="100"
            :src="$refs.basicForm.form.getFieldValue('wxapp_api_cover')[0].url"
            alt="avatar"
          >
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">
              上传
            </div>
          </div>
        </a-upload>
      </template>
    </basic-form>
    <div class="btn-container">
      <a-button
        :loading="btnIsLoading"
        type="primary"
        style="margin-left:20px;"
        @click="$emit('handleSubmit')"
      >
        保存
      </a-button>
    </div>
  </div>
</template>
<script>
import { formData } from '../data/index';
export default {
  props: ['btnIsLoading'],
  data() {
    return {
      formData,
      loading: false,
    };
  },
  mounted() {},
  methods: {
    delImg1(){
      this.$refs.basicForm.form.setFieldsValue({'wxapp_cover': []});
    },
    delImg2(){
      this.$refs.basicForm.form.setFieldsValue({'wxapp_cover_two': []});
    },
    delImg3(){
      this.$refs.basicForm.form.setFieldsValue({'wxapp_covers': []});
    },
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
      }
      if (e && e.file.status === 'done') {
        const fileList = [
          {
            uid: e.file.response.data.id,
            status: 'done',
            name: 'img',
            url: e.file.response.data.url,
          },
        ];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('图片小于10M！');
      }
      return isLt2M;
    },
  },
};
</script>
<style lang="scss" scoped>
.web-message-container {
.btn-container{
  text-align: right;
}
}
</style>